export default {
  SET_CONSULT(state, data) {
    state.consult = data;
  },

  SET_DOCUMENTS_CONSULTED(state, data) {
    state.documentsConsulted = data;
  },

  SET_QUOTA(state, data) {
    state.quota = data;
  },
};
